module.exports = __webpack_public_path__ + "img/服務條款5.06d8b4ce.png";